import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import useSearchPagination from "./../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { Link } from "react-router-dom";
import Highlighter from "react-highlight-words";

export default function ListDataVendor({
  list = [],
  editData,
  deleteData,
  loading,
  titles = [],
  addData,
  listLoading,
}) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    CountPerPage,
    Search,
    currentList,
  } = useSearchPagination(list);
  const [searchWords, setSearchWords] = useState([]);

  return (
    <div className="pt-2">
      <div className="flex flex-wrap items-center gap-2">
        {checkAccess("Vendor", "vendor-create") && (
          <Link to="/dashboard/recruitment-agency/create">
            <button
              className="p-2 bg-red uppercase text-white rounded-md"
              onClick={addData}
            >
              Add New Recruitment Agency +
            </button>
          </Link>
        )}
        <Search
          searchKey={[
            "vendor_id",
            "name",
            "email",
            "address",
            "email",
            "mobile",
            "nationality.name",
            "authorized_person_name",
          ]}
          setSearchWords={setSearchWords}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div
        className={`grid grid-cols-table-vendor auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {listLoading && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-full">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        {!listLoading && <NoDataFound />}

        {!listLoading &&
          currentList.map((list, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.vendor_id || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.name || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.short_name || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.email || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.nationality?.name || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.address || "-"}
                />
              </p>
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.authorized_person_name || "-"}
                />
              </p>
              <div className="flex gap-3 min-w-fit ">
                {checkAccess("Vendor", "vendor-edit") ? (
                  <button
                    className={
                      listLoading || currentList?.length <= 0
                        ? "p-1 px-2 rounded-md ring-1 ring-slate-600 opacity-50"
                        : "p-1 px-2 rounded-md ring-1 ring-slate-600"
                    }
                    onClick={() => editData(list.id, list)}
                    disabled={
                      loading.edit || listLoading || currentList?.length <= 0
                    }
                  >
                    {loading.edit && loading.loadingId === list.id ? (
                      <CgSpinner className="animate-spin mx-auto" />
                    ) : (
                      <CiEdit size={"1.4rem"} />
                    )}
                  </button>
                ) : (
                  <button className="p-1 px-2 rounded-md ring-1 ring-slate-200">
                    --
                  </button>
                )}

                {checkAccess("Vendor", "vendor-delete") ? (
                  <button
                    className={
                      listLoading || currentList?.length <= 0
                        ? "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red opacity-50"
                        : "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                    }
                    onClick={() =>
                      deleteData((oldState) => ({ open: true, id: list.id }))
                    }
                    disabled={
                      loading.delete || listLoading || currentList?.length <= 0
                    }
                  >
                    {loading.delete && loading.loadingId === list.id ? (
                      <CgSpinner className="animate-spin mx-auto" />
                    ) : (
                      <MdDeleteOutline size={"1.4rem"} />
                    )}
                  </button>
                ) : (
                  <button className="p-1 px-2 rounded-md ring-1 ring-slate-200">
                    --
                  </button>
                )}
              </div>
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-full `}
              />
            </React.Fragment>
          ))}
      </div>
      <Pagination />
    </div>
  );
}
